<template>
  <CustomPage title="我的顾客" style="background: #f7f7f7"
    ><div slot="content" style="height: 100%">
      <div class="flex m-3 justify-between">
        <div class="flex w-1/2 justify-center">
          <div>消费金额</div>
          <div class="flex flex-col items-center" style="color: #c6c6c6">
            <Icon
              class="transform -rotate-90 -mb-1 mt-1"
              :class="active === 0 ? 'active' : ''"
              name="play"
              size="10px"
              @click="active = 0"
            /><Icon
              class="transform rotate-90"
              :class="active === 1 ? 'active' : ''"
              name="play"
              size="10px"
              @click="active = 1"
            />
          </div>
        </div>
        <div class="flex w-1/2 justify-center">
          <div>消费单数</div>
          <div class="flex flex-col items-center" style="color: #c6c6c6">
            <Icon
              class="transform -rotate-90 -mb-1 mt-1"
              :class="active === 2 ? 'active' : ''"
              name="play"
              size="10px"
              @click="active = 2"
            /><Icon
              class="transform rotate-90"
              :class="active === 3 ? 'active' : ''"
              name="play"
              size="10px"
              @click="active = 3"
            />
          </div>
        </div>
      </div>
      <div class="m-3">
        <div
          v-for="i in 3"
          :key="i"
          class="
            heavyshadow
            bg-white
            rounded-lg
            flex
            justify-between
            p-3
            items-center
            my-3
          "
        >
          <div class="flex">
            <div style="height: 52px; width: 52px" class="mr-3">
              <img
                class="h-full w-full rounded-full"
                src="https://img01.yzcdn.cn/vant/cat.jpeg"
                alt=""
              />
            </div>
            <div style="line-height: 52px" class="text-sm font-medium">
              程兰震
            </div>
          </div>
          <div class="flex flex-col text-right justify-between">
            <div>
              <div class="font-medium">¥39328.00</div>
              <div class="text-xs" style="color: #999999">消费金额</div>
            </div>
            <div>
              <div class="font-medium">23次</div>
              <div class="text-xs" style="color: #999999">消费次数</div>
            </div>
          </div>
        </div>
      </div>
    </div></CustomPage
  >
</template>

<script>
import CustomPage from "@/components/custom-page.vue";
import { Icon } from "vant";
export default {
  components: { CustomPage, Icon },
  data() {
    return {
      active: -1,
    };
  },
};
</script>

<style scoped>
.active {
  color: black;
}
</style>